import { render, staticRenderFns } from "./BCGovNavBar.vue?vue&type=template&id=de63a1e4&scoped=true"
import script from "./BCGovNavBar.vue?vue&type=script&lang=js"
export * from "./BCGovNavBar.vue?vue&type=script&lang=js"
import style0 from "./BCGovNavBar.vue?vue&type=style&index=0&id=de63a1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de63a1e4",
  null
  
)

export default component.exports